module.exports = __webpack_public_path__ + "img/new1.ddf999cd.png";